// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/service-worker", { scope: "/" })
}

import "trix"

import "@rails/actiontext"

// Close any open <dialog> elements before Turbo renders new content.
// dialogs opened via showModal() live in the browser's top layer — if Turbo
// morphs the page and just removes the `open` attribute without calling
// dialog.close(), the native backdrop can remain and block all pointer events.
document.addEventListener("turbo:before-render", () => {
  document.querySelectorAll("dialog[open]").forEach((dialog) => dialog.close())
})
